module.exports = __webpack_public_path__ + "img/photo-projects-abajatemperatura.082424d1.png";